

import React from 'react'
import { Container, Row, Table, Col } from 'react-bootstrap';
import QRCode from "react-qr-code";
import { thousandSeperate } from "../../../helpers";

export default class OrderBillWithName extends React.PureComponent {
    render() {
        let data = this.props.data
        return (
            <div style={{ padding: 10, paddingTop: 32 }}>
                <div className="d-flex flex-row col-12 flex-wrap">
                    {data?.map((item, index) => <div key={index} className="col-6" style={{ paddingLeft: 70, paddingRight: 70, paddingTop: 32, border: '1px dashed black' }}>
                        <div className="d-flex col-12 flex-row justify-content-between">
                            <div>
                                <p style={{ fontWeight: "bold", fontSize: 24, marginTop: 10 }}><u>ໃບຈັດສົ່ງ</u></p>
                                <div style={{ fontWeight: "bold", fontSize: 20, marginTop: 10 }}>ຜູ້ສົ່ງ: {item?.pageName ?? ""}</div>
                            </div>
                            <QRCode value="http://lailaolab.com/" size={70} />
                        </div>
                        <hr />
                        <p style={{ fontWeight: "bold", fontSize: 16, marginTop: 24 }}>ຜູ້ຮັບ: {item?.cfName}</p>
                        <p style={{ fontWeight: "bold", fontSize: 16, marginTop: 24 }}>ເບີໂທ:</p>
                        <p style={{ fontWeight: "bold", fontSize: 16, marginTop: 24 }}>ທີ່ຢູ່:</p>
                        <p style={{ fontWeight: "bold", fontSize: 16, marginTop: 24 }}>ຂົນສົ່ງ:</p>
                        <p style={{ fontWeight: "bold", fontSize: 16, marginTop: 24 }}>ລາຄາ: {thousandSeperate(item?.totalPrice ?? 0)}</p>
                        <div style={{ marginTop: 32 }} />
                        <div className="d-flex justify-content-center align-items-end" style={{ marginBottom: 20 }}>
                            <p>@Lailaolab ICT Solution</p>
                        </div>
                    </div>)}
                </div>
            </div>
        );
    }
}